export function formatUSD(value: number|null): string {
    if(value === null || value === undefined) {
        return 'unknown';
    }
    const result = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value);
    return `$${  result.replace('$', '')}`;
}
